





















import Vue from 'vue';
import { describeBlowValue } from '@/models/skills/blows/registry';
import { IBlowDescription } from '@/models/skills/blows/types';
import { collectSpans, collectStateVfxIds } from '@/models/skills/blows/spans';
import RawParams from './RawParams.vue';
import StateEffect from '@/components/skill/StateEffect.vue';

export default Vue.extend({
    name: 'BlowChildCard',
    components: {
        RawParams,
        StateEffect,
    },
    beforeCreate() {
        // break the BlowSegments <-> BlowChildCard cycle
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        (this.$options.components as any).BlowSegments = require('./BlowSegments.vue').default;
    },
    props: {
        blowId: {
            type: Number as () => number,
            required: true,
        },
        params: {
            type: String as () => string,
            default: '',
        },
        durationMs: {
            type: Number as () => number,
            default: 0,
        },
    },
    computed: {
        desc(): IBlowDescription {
            return describeBlowValue(this.blowId, this.params, this.durationMs);
        },
        spans(): Array<[number, number]> {
            if (this.desc && this.desc.segments) {
                return collectSpans(this.desc.segments);
            }
            return [];
        },
        vfxIds(): number[] {
            if (this.desc && this.desc.segments) {
                return collectStateVfxIds(this.desc.segments);
            }
            return [];
        },
    },
});
